.trigger {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 160px;
  height: 36px;
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  background: var(--light-gray);
  color: var(--text-primary);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  cursor: pointer;
}

.triggerFull {
  composes: trigger;
  width: 100%;
}

.trigger:hover {
  background: var(--gray-300);
}

.trigger:focus-visible {
  outline: 2px solid var(--light-blue);
  outline-offset: 2px;
}

.chevron {
  font-size: 12px;
}

.menu {
  display: flex;
  flex-direction: column;
  width: 235px;
}

.popoverFull {
  width: 100%;
}

.menuFull {
  composes: menu;
  width: auto;
}

.panel {
  padding: 8px 0;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgb(0 0 0 / 27%);
}

.heading {
  display: flex;
  min-height: 32px;
  align-items: center;
  padding: 0 16px;
  color: var(--text-secondary);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.option {
  display: flex;
  min-height: 32px;
  align-items: center;
  padding: 0 16px;
  color: var(--text-primary);
  font-size: 12px;
  line-height: 20px;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 4px 12px;
}

.actions .action {
  height: 28px;
  min-width: 52px;
  padding: 6px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  box-shadow: none;
}
